export default __webpack_public_path__ + "static/media/ny.4fcdc7cc.png";